import(/* webpackMode: "eager" */ "/vercel/path0/src/app/offers/page.tsx");
